/* LK SEO (Okt 2026): Datenschutz-Text wird erst beim Öffnen nachgeladen */
const lkLoadPrivacy = (cookiePopup) => {
    const content = cookiePopup.querySelector('.cookie-popup__content');
    if (!content || content.dataset.loaded) return;
    content.dataset.loaded = '1';
    content.innerHTML = '<p style="text-align:center;opacity:.6">Wird geladen …</p>';
    fetch(cookiePopup.dataset.src, { credentials: 'same-origin' })
        .then((r) => { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then((html) => { content.innerHTML = html; })
        .catch(() => {
            content.innerHTML = '<p style="text-align:center"><a href="' + cookiePopup.dataset.fallback + '" target="_blank" rel="noopener">Datenschutzerklärung öffnen</a></p>';
            delete content.dataset.loaded;
        });
};

const observeCookieBanner = () => {
    const targetId = 'cookieconsent:desc';

    const observer = new MutationObserver((mutations, obs) => {
        const targetSpan = document.getElementById(targetId);

        if (targetSpan) {
            const link = targetSpan.querySelector('a');

            if (link) {
                const cookiePopup = document.querySelector('.cookie-popup');
                const cookiePopupWrapper = cookiePopup?.querySelector('.cookie-popup__wrapper');
                const cookiePopupCloseBtn = cookiePopup?.querySelector('.cookie-popup__close');

                link.addEventListener('click', (e) => {
                    e.preventDefault();
                    if (cookiePopup) {
                        lkLoadPrivacy(cookiePopup);
                        cookiePopup.classList.add('open');
                    }
                });

                cookiePopupCloseBtn?.addEventListener('click', () => {
                    cookiePopup.classList.remove('open');
                });

                document.addEventListener('click', (e) => {
                    if (
                        cookiePopup?.classList.contains('open') &&
                        !cookiePopupWrapper.contains(e.target) &&
                        !link.contains(e.target)
                    ) {
                        cookiePopup.classList.remove('open');
                    }
                });

                obs.disconnect();
            }
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
};

observeCookieBanner();